import ctl from '@netlify/classnames-template-literals'
import { useAtomValue } from 'jotai'
import { ReactNode } from 'react'
import { transformerPreviewStateAtom, transformerStateAtom } from './state'
import { useTransformerStore } from './transformer-store'

export function TransformerChildWrapper(
	{ children, passthroughClassName }: { children: ReactNode; passthroughClassName?: string },
) {
	const store = useTransformerStore()

	const previewState = useAtomValue(transformerPreviewStateAtom, { store })
	const mainState = useAtomValue(transformerStateAtom, { store })

	const state = previewState ?? mainState

	const style = {
		transform:
			`translate(${state.offset.x}px, ${state.offset.y}px) scale(${state.scale}) rotate(${state.rotation}rad)`,
	}

	// this widget should only ever be shown on focus, so it should never be a trigger to lose focus
	return (
		<div
			style={style}
			className={ctl(`${passthroughClassName} pointer-events-auto`)}
			data-prevent-focus-loss
		>
			{children}
		</div>
	)
}
